"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _reactTextMask = _interopRequireDefault(require("react-text-mask"));

var _createNumberMask = _interopRequireDefault(require("text-mask-addons/dist/createNumberMask"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CurrencyInput = function CurrencyInput(_ref) {
  var alignment = _ref.alignment,
      className = _ref.className,
      guide = _ref.guide,
      inputRef = _ref.inputRef,
      maskOptions = _ref.maskOptions,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      placeholder = _ref.placeholder,
      reference = _ref.forwardRef,
      value = _ref.value,
      restOfProps = _objectWithoutProperties(_ref, ["alignment", "className", "guide", "inputRef", "maskOptions", "onChange", "onBlur", "placeholder", "forwardRef", "value"]);

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      formattedValue = _useState2[0],
      setFormattedValue = _useState2[1];

  var handleInputChange = function handleInputChange(e) {
    var valueFromEvent = e.target.value;
    var normalized = valueFromEvent.replace(/[^\d.]/g, '');
    /**
     * Expose `rawValue` and `formattedValue` on the event object
     */

    e.target.rawValue = normalized;
    e.target.formattedValue = valueFromEvent;

    if (typeof onChange === 'function') {
      onChange(e);
    }

    setFormattedValue(valueFromEvent);
  };

  var sanitizeInput = function sanitizeInput(e) {
    var _e$target = e.target,
        _e$target$value = _e$target.value,
        valueFromEvent = _e$target$value === void 0 ? '' : _e$target$value,
        _e$target$rawValue = _e$target.rawValue,
        rawValue = _e$target$rawValue === void 0 ? '' : _e$target$rawValue;
    /**
     * Sanitize value in case value ends with dot
     */

    var formatted = valueFromEvent.replace(/[.]$/, '.00');
    var formattedRaw = rawValue.replace(/[.]$/, '.00');
    /**
     * Expose `rawValue` and `formattedValue` on the event object
     */

    e.target.formattedValue = formatted;
    e.target.rawValue = formattedRaw;

    if (typeof onBlur === 'function') {
      onBlur(e);
    }

    setFormattedValue(formatted);
  };

  var numberMask = (0, _createNumberMask.default)(maskOptions);
  var alignClassName = (0, _classnames.default)(className, {
    'pds-input-base--text--align-left': alignment === 'left',
    'pds-input-base--text--align-right': alignment === 'right'
  });
  return _react.default.createElement(_reactTextMask.default, _extends({}, restOfProps, {
    ref: function ref(_ref2) {
      /**
       * Pass the input reference to the parent
       * Need to create an object with a "current" property to match the API for non-custom inputs
       */
      if (typeof inputRef === 'function' && _ref2) {
        inputRef({
          current: _ref2.inputElement
        });
      }
    },
    className: alignClassName,
    guide: guide,
    mask: numberMask,
    onChange: handleInputChange,
    onBlur: sanitizeInput,
    placeholder: placeholder,
    value: formattedValue.length ? formattedValue : value
  }));
};

CurrencyInput.propTypes = {
  alignment: (0, _propTypes.oneOf)(['left', 'right']),
  className: _propTypes.string,
  forwardRef: (0, _propTypes.shape)({
    current: _propTypes.object
  }),
  guide: _propTypes.bool,
  inputRef: _propTypes.func,
  // See https://github.com/text-mask/text-mask/tree/master/addons#createnumbermask for options
  maskOptions: (0, _propTypes.shape)({}),
  onChange: _propTypes.func,
  onBlur: _propTypes.func,
  placeholder: _propTypes.string,
  value: _propTypes.string
};
CurrencyInput.defaultProps = {
  alignment: 'left',
  className: null,
  forwardRef: {},
  guide: false,
  inputRef: null,
  maskOptions: {},
  onChange: null,
  onBlur: null,
  value: '',
  placeholder: '$'
};

var _default = (0, _react.forwardRef)(function (props, ref) {
  return _react.default.createElement(CurrencyInput, _extends({}, props, {
    forwardRef: ref
  }));
});

exports.default = _default;
